import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ProductListService } from './product-list.service';
import { SnackBarService } from '../../services/snack-bar.service';
import { TranslateService } from '@ngx-translate/core';
import { ProductGroup } from '../../services/products.service';

@Component({
    selector: 'app-product-list',
    templateUrl: './product-list.component.html',
    styleUrls: ['./product-list.component.scss'],
})
export class ProductListComponent implements OnInit, OnDestroy {
    private unsubscribe$: Subject<void> = new Subject<void>();
    public productListViewModel: ProductGroup[];
    public productsCounter: string;

    constructor(
        public productListService: ProductListService,
        private snackBarService: SnackBarService,
        private translateService: TranslateService
    ) {}

    public ngOnInit() {
        this.productListService.productList$.pipe(takeUntil(this.unsubscribe$)).subscribe({
            next: (productList) => {
                this.productListViewModel = productList.groups.map((group) => ({
                    ...group,
                    products: group.products.filter((p) => p.selected),
                }));
                this.productsCounter = productList.groups
                    .flatMap((group) => group.products.filter((product) => product.selected))
                    .length.toString();
            },
            error: (error) => {
                this.snackBarService.openSnackBar({
                    message: this.translateService.instant('CONFIGURATION.SNACK_BAR.FETCH_PRODUCTS.ERROR'),
                    isFailure: true,
                });
                if (error.error?.message) {
                    // tslint:disable-next-line:no-console
                    console.log(error.error.message);
                }
            },
        });
    }

    public ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
